import i18n from '@/plugins/i18n/index.js'

export default function transTypes () {
  return [
    { type: i18n.t('general.eventTypeCamping'), label: 'camping' },
    { type: i18n.t('general.eventTypeAttraction'), label: 'attraction' },
    { type: i18n.t('general.eventTypeRace'), label: 'race' },
    { type: i18n.t('general.eventTypeDinner'), label: 'dinner' },
    { type: i18n.t('general.eventTypeWorkshop'), label: 'workshop' },
    { type: i18n.t('general.eventTypeSignature'), label: 'signature' },
    { type: i18n.t('general.eventTypeConcert'), label: 'concert' },
    { type: i18n.t('general.eventTypeConference'), label: 'conference' },
    { type: i18n.t('general.eventTypeConvention'), label: 'convention' },
    { type: i18n.t('general.eventTypeMeetup'), label: 'meetup' },
    { type: i18n.t('general.eventTypeFair'), label: 'fair' },
    { type: i18n.t('general.eventTypeFestival'), label: 'festival' },
    { type: i18n.t('general.eventTypeParty'), label: 'party' },
    { type: i18n.t('general.eventTypeCompetition'), label: 'competition' },
    { type: i18n.t('general.eventTypeOther'), label: 'other' },
    { type: i18n.t('general.eventTypeProjection'), label: 'pojection' },
    { type: i18n.t('general.eventTypeRally'), label: 'rally' },
    { type: i18n.t('general.eventTypeSeminar'), label: 'seminar' },
    { type: i18n.t('general.eventTypeTournament'), label: 'tournament' },
    { type: i18n.t('general.eventTypeVisit'), label: 'visit' }

    // { type: i18n.t('eventTypeCamping'), value: 1, label: 'camping' },
    // { type: i18n.t('eventTypeAttraction'), value: 2, label: 'attraction' },
    // { type: i18n.t('eventTypeRace'), value: 3, label: 'race' },
    // { type: i18n.t('eventTypeDinner'), value: 4, label: 'dinner' },
    // { type: i18n.t('eventTypeWorkshop'), value: 5, label: 'workshop' },
    // { type: i18n.t('eventTypeSignature'), value: 6, label: 'signature' },
    // { type: i18n.t('eventTypeConcert'), value: 7, label: 'concert' },
    // { type: i18n.t('eventTypeConference'), value: 8, label: 'conference' },
    // { type: i18n.t('eventTypeConvention'), value: 9, label: 'convention' },
    // { type: i18n.t('eventTypeMeetup'), value: 10, label: 'meetup' },
    // { type: i18n.t('eventTypeFair'), value: 11, label: 'fair' },
    // { type: i18n.t('eventTypeFestival'), value: 12, label: 'festival' },
    // { type: i18n.t('eventTypeParty'), value: 13, label: 'party' },
    // { type: i18n.t('eventTypeCompetition'), value: 14, label: 'competition' },
    // { type: i18n.t('eventTypeOther'), value: 15, label: 'other' },
    // { type: i18n.t('eventTypeProjection'), value: 16, label: 'pojection' },
    // { type: i18n.t('eventTypeRally'), value: 17, label: 'rally' },
    // { type: i18n.t('eventTypeSeminar'), value: 18, label: 'seminar' },
    // { type: i18n.t('eventTypeTournament'), value: 19, label: 'tournament' },
    // { type: i18n.t('eventTypeVisit'), value: 20, label: 'visit' }
  ]
}
